import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../App.css';

function Layout({ children }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="layout">
        {/* Navigation */}
        <nav className="navbar">
        <div className="container">
            <div className="logo"><Link to="/" className="nav-link" onClick={closeMobileMenu}><span className="logo-box">Aamb</span></Link></div>
            <button className="menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle mobile menu">
              {mobileMenuOpen ? '✕' : '☰'}
            </button>
            <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
                <Link to="/" className="nav-link" onClick={closeMobileMenu}>Home</Link>
                <Link to="/about" className="nav-link" onClick={closeMobileMenu}>About Us</Link>
            </div>
            </div>
        </nav>

        {/* Page content goes here */}
        <div className="page-content">
            {children}
        </div>

        {/* Footer Section */}
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-brand">
                        <h3>AAMB</h3>
                        <p>Enterprise-grade cloud solutions with startup agility. Trusted by federal contractors and enterprises.</p>
                        <p className="footer-tagline">AWS-certified cloud architects delivering scalable infrastructure</p>
                    </div>
                    <div className="footer-section">
                        <h4>Solutions</h4>
                        <ul>
                            <li><a href="#services">Custom Software</a></li>
                            <li><a href="#services">Cloud Infrastructure</a></li>
                            <li><a href="#services">SaaS Development</a></li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h4>Company</h4>
                        <ul>
                            <li><a href="/about">About Us</a></li>
                            <li><a href="mailto:mgmt@aamb.dev">Contact</a></li>
                            <li><a href="/about">Capabilities</a></li>
                        </ul>
                    </div>
                </div>
                <div className="copyright">
                    <p>© {new Date().getFullYear()} AAMB LLC. All rights reserved. | Woman-Owned Small Business</p>
                </div>
            </div>
        </footer>
    </div>
  );
}

export default Layout;